(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npRowInfoTooltip', ['$document', function ($document) {
        return {
            restrict: 'E',
            controller: ['$scope', '$sce', controller],
            controllerAs: 'vm',
            scope: {
                objectTooltip: '=',
                backgroundColor: '='
            },
            templateUrl: '/app/shared/grid/rowInfoTooltip.html',
            replace: true
        };
    }]);

    function controller($scope, $sce) {
        var vm = this;
        vm.htmlText = '';
        vm.init = init;

        function init() {
            var html = '<div class="table-css ' + $scope.backgroundColor + '">';
            if($scope.objectTooltip && $scope.objectTooltip.length > 0)
            {
                $scope.objectTooltip.forEach(function (item) {
                    html += "    <div class='table-row'><span class='tooltip-element'><b>" + item.label;
                    html += "</b></span> <span class='table-cell'>"
                    html += item.data + "</span></div>";
                });
            }
            html += '</div>';
            vm.htmlText = $sce.trustAsHtml(html);
        }
    }

})();